module.exports = __webpack_public_path__ + "static/media/code.68a01589.jpeg";